import classNames from 'classnames';
import Logo from 'layouts/header/Logo';
import React from 'react';
import { FC } from 'types';
import classes from './index.module.css';

type TProps = {};

const HeaderLogoOnly: FC<TProps> = () => {
  return (
    <nav className={classNames('navbar p-0', classes.navbar)}>
      <div
        className={classNames(
          'container d-flex justify-content-between flex-nowrap',
          classes.container
        )}
      >
        <div className="d-flex align-items-center">
          <Logo noLinks />
        </div>
      </div>
    </nav>
  );
};

export default HeaderLogoOnly;
